import React, {Component} from 'react';
import Styles from './style.css';
import cx from "classnames";
import {langRegister} from "../../services/langRegister";
import {marketRegister} from "../../services/marketRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import queryString from "query-string";
import {dataRegister} from "../../services/dataRegister";

class SignupAdsInstagram extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selected: false,
            learn_more: false,
            quotes: null,
            market: null,
            image: null,
            tips: [],
            industry: {},
            customIndustry: null,
            available: false
        };
    };

    componentDidMount() {
        this._updateData();
    }

    _updateData() {
        this.setState({
            tips: [
                {title: this._renderText("item_54")},
                {title: this._renderText("item_55")},
                {title: this._renderText("item_56")},
                {title: this._renderText("item_57")},
                {title: this._renderText("item_58")},
                {title: this._renderText("item_59")}
            ],
            selected: this.props.setChannel,
            quotes: this.props.setQuotes,
            industry: this.props.setIndustry,
            customIndustry: this.props.setCustomIndustry,
            image: this.props.setImage,
            market: salesChannelRegister.get("market"),
            available: this.props.setAvailable
        });
    }

    /*
    _placement(){
        try{
            let query = {
                industry: this.state.industry.name,
                region: salesChannelRegister.get("market"),
                quotes: "| " + this._renderQuotes(),
                website: this._renderText("item_60") + salesChannelRegister.get("market"),
                image: this.state.image.url,
                saleschannel: "adbop"
            };
            const stringified = queryString.stringify(query);
            window.open('https://placement.'+dataRegister.domain+"/"+langRegister.lang()+"/instagram?" + stringified, '_blank');
        }catch (e) {
            window.open('https://placement.'+dataRegister.domain+"/"+langRegister.lang()+"/instagram", '_blank');
        }
    }
    */

    _placement(){
        try{
            let query = {
                industry: this.state.industry.name,
                region: salesChannelRegister.get("market"),
                quotes: "| " + this._renderQuotes(),
                website: this._renderText("item_60") + salesChannelRegister.get("market"),
                //image: this.state.image.id === "uploaded_image"?"uploaded_image":this.state.image.url,
                saleschannel: 'adbop'
            };

            try{
                if(this.state.image.url && this.state.image.id !== "uploaded_image"){
                    query.image = this.state.image.url;
                }
            }catch (e) {}

            /*
            if(this.state.image.id === "uploaded_image"){
                query.image = this.state.image.web_url?this.state.image.web_url:"uploaded_image";
            }else{
                query.image = this.state.image.url;
            }
            */

            const stringified = queryString.stringify(query);
            let url = 'https://placement.'+dataRegister.domain;
            //let url = 'http://localhost:3001';
            var popUp = window.open(url +"/"+langRegister.lang()+"/instagram?" + stringified, '_blank');
            if(this.state.image.data_url){
                setTimeout(() => {
                    popUp.postMessage(this.state.image.data_url, url);
                }, 500)
            }

        }catch (e) {
            window.open('https://placement.'+dataRegister.domain+"/"+langRegister.lang()+"/instagram", '_blank');
        }
    }

    /*
    _renderQuotes() {
        if (this.state.quotes) {
            let quotes_string = "";
            if (!this.state.quotes.custom) {
                let i = 1;
                for (let key in this.state.quotes) {
                    quotes_string += this.state.quotes[key].slogan + (Object.keys(this.state.quotes).length > i ? " - " : "");
                    i++;
                }
            } else {
                quotes_string = this.state.quotes.text;
            }
            return quotes_string
        }
    }
    */

    _renderAdImage() {
        if (this.state.image) {
            return (
                <div className={Styles.imagesContainerItem}>
                    <div className={Styles.imagesContainerItemInner}>
                        {
                            !this.state.image.file &&
                            <img src={this.state.image.url}/>
                        }
                        {
                            this.state.image.file &&
                            <div style={{backgroundImage: "url(" + this.state.image.url + ")"}} className={Styles.imagesContainerItemInnerUploadImage}/>
                        }
                    </div>
                </div>
            )
        }
    }

    _renderQuotes() {
        if (this.state.quotes) {
            let quotes_string = "";
            if (!this.state.quotes.custom) {
                let i = 1;
                var sortable = [];
                for (var key in this.state.quotes) {
                    sortable.push([this.state.quotes[key], this.state.quotes[key].index]);
                }
                sortable.sort(function(a, b) {
                    return a[1] - b[1];
                });
                sortable.map((item) => {
                    quotes_string += item[0].slogan + (sortable.length > i ? " - " : "");
                    i++;
                });

                if(this.state.customIndustry){
                    quotes_string = this.state.customIndustry + " | " + quotes_string;
                }

            } else {
                quotes_string = this.state.quotes.text;
            }
            return quotes_string
        }
    }

    _renderText(item) {
        return langRegister.get("signup-ads", item);
    }

    render() {
        return (
            <div className={Styles.contentContainerLeftItem}>
                {
                    this.state.selected && this.state.available &&
                    <div onClick={() => this._placement()} className={Styles.contentContainerLeftItemPlacement}>
                        <img src={require("../../assets/images/plus_sign_white_small.png")} className={Styles.contentContainerLeftItemPlacementIcon}/>
                    </div>
                }
                <div onMouseDown={() => {
                    if (this.state.selected) {
                        this.props.removeChannel("instagram"); this.setState({selected: false})
                    }
                }}
                     className={
                         cx(Styles.contentContainerLeftItemInner,
                             {
                                 [Styles.contentContainerLeftItemInnerActive]: !this.state.selected,
                             })
                     }>
                    <div
                        className={
                            cx(Styles.contentContainerLeftItemInnerOverlay,
                                {
                                    [Styles.contentContainerLeftItemInnerOverlayActive]: !this.state.selected,
                                })
                        }
                    >
                        {
                            !this.state.selected &&
                            <div onClick={() => {
                                if (this.state.available) {
                                    this.props.selectChannel("instagram");
                                    this.setState({selected: !this.state.selected})
                                }
                            }}
                                 className={
                                     cx(Styles.contentContainerLeftItemInnerOverlayButton,
                                         {
                                             [Styles.contentContainerLeftItemInnerOverlayButtonDisabled]: !this.state.available,
                                         })
                                 }>
                                {
                                    this.state.available &&
                                    this._renderText("item_18")
                                }
                                {
                                    !this.state.available &&
                                    this._renderText("item_65")
                                }
                            </div>
                        }
                        <div className={Styles.contentContainerLeftItemInnerOverlayTitle}>
                            Instagram <span className={Styles.contentContainerLeftItemInnerOverlayTitleSmall}>social ads</span>
                        </div>
                        {
                            this.state.tips.filter((item, key) => {
                                return !this.state.learn_more && key < 3 || this.state.learn_more && key > 2
                            }).map((prop, i) => {
                                return (
                                    <div key={i}
                                         className={Styles.contentContainerLeftItemInnerOverlayItem}>
                                        &#x2b; {prop.title}
                                    </div>
                                )
                            })
                        }
                        <div onClick={() => {this.setState({learn_more: !this.state.learn_more})}} className={Styles.contentContainerLeftItemInnerOverlayReadMore}>
                            {
                                this.state.learn_more &&
                                <span>{this._renderText("item_28")}</span>
                            }
                            {
                                !this.state.learn_more &&
                                <span>{this._renderText("item_29")}</span>
                            }
                        </div>
                    </div>
                    <div className={Styles.contentContainerLeftItemInstagramInnerTop}>
                        <div className={Styles.contentContainerLeftItemInstagramInnerTopIcon}>
                            <img
                                className={Styles.contentContainerLeftItemInstagramInnerTopIconLogo}
                                src={require("../../assets/images/adbop_logo_small_new.svg")}/>
                        </div>
                        <div
                            className={Styles.contentContainerLeftItemInstagramSponsorContainer}>
                            <div
                                className={Styles.contentContainerLeftItemInstagramSponsorContainerName}>
                                adBop
                            </div>
                            <div
                                className={Styles.contentContainerLeftItemInstagramSponsorContainerText}>
                                {this._renderText("item_13")}
                            </div>
                        </div>
                    </div>
                    {this._renderAdImage()}
                    <div className={Styles.contentContainerLeftInstagramItemReadmoreContainer}>
                        <div
                            className={Styles.contentContainerLeftInstagramItemReadmoreContainerText}>
                            {this._renderText("item_14")}
                        </div>
                        <img src={require("../../assets/images/arrow-right.svg")}
                             className={Styles.contentContainerLeftInstagramItemReadmoreContainerArrow}/>
                    </div>
                    <div className={Styles.contentContainerLeftInstagramItemIconsContainer}>
                        <img src={require("../../assets/images/heart.svg")}
                             className={Styles.contentContainerLeftInstagramItemIconsContainerHeart}/>
                        <img src={require("../../assets/images/message-circle.svg")}
                             className={Styles.contentContainerLeftInstagramItemIconsContainerChat}/>
                    </div>
                    <div className={Styles.contentContainerLeftInstagramItemAdText}>
                                                <span className={Styles.contentContainerLeftInstagramItemAdTextIndustry}>{this.state.industry.name}{" "}</span>|{" "}
                        {this._renderQuotes()}
                    </div>
                </div>
                <div className={Styles.contentContainerLeftItemBottom}>
                    <div
                        className={
                            cx(Styles.contentContainerLeftItemBottomIconContainer,
                                {
                                    [Styles.contentContainerLeftItemBottomIconContainerActive]: this.state.selected,
                                })
                        }
                    >
                        <img
                            className={Styles.contentContainerLeftItemBottomIconContainerIconInstagram}
                            src={require("../../assets/images/instagram_logo_icon.svg")}/>
                    </div>
                    {
                        !this.state.selected && this.state.available &&
                        <img onClick={() => {this.props.selectChannel("instagram"); this.setState({selected: !this.state.selected})}}
                             className={Styles.contentContainerLeftItemBottomSlider}
                             src={require("../../assets/images/slider_deactive.svg")}/>
                    }
                    {
                        this.state.selected && this.state.available &&
                        <img onClick={() => {this.props.selectChannel("instagram"); this.setState({selected: !this.state.selected})}}
                             className={Styles.contentContainerLeftItemBottomSlider}
                             src={require("../../assets/images/slider_active.svg")}/>
                    }
                    {
                        !this.state.selected &&
                        <div className={Styles.contentContainerLeftItemBottomDots}>
                            <div className={
                                cx(Styles.contentContainerLeftItemBottomDotsItem,
                                    {
                                        [Styles.contentContainerLeftItemBottomDotsItemActive]: !this.state.learn_more,
                                    })
                            }/>
                            <div className={Styles.contentContainerLeftItemBottomDotsItemLine}/>
                            <div className={
                                cx(Styles.contentContainerLeftItemBottomDotsItem,
                                    {
                                        [Styles.contentContainerLeftItemBottomDotsItemActive]: this.state.learn_more,
                                    })
                            }/>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default SignupAdsInstagram;


// WEBPACK FOOTER //
// ./src/components/signup-ads-instagram/component.js